// removed by extract-text-webpack-plugin
module.exports = {"root":"send_root_exrjv0","small":"send_small_40gyaz"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/send/send.scss
// module id = 569
// module chunks = 0